import { ErrorModal, getMomentTz, HelmetDexteel } from "@dexteel/mesf-core";
import { Button, Grid, Paper, TextField, Typography } from "@mui/material";
import type { TextFieldProps } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import { LadleSelector } from "../../../shared/selectors/LadleSelector";
import { DatePickerModal } from "./components/DatePickerModal";
import { LadleMaintenanceTable } from "./components/LadleMaintenanceTable";
import { useFetchData } from "./hooks/useFetchData";

const moment = getMomentTz();

export const LadlesMaintenancePage = (): JSX.Element => {
  const [showModal, setShowModal] = useState<"PLUG" | "RELINING" | "">("");
  const [dateSelected, setDateSelected] = useState<Date | null>(
    moment().subtract(30, "days").toDate(),
  );
  const [ladleSelected, setLadleSelected] = useState<number | null>(1);

  const { ladleRelining, loading, error, setError, refetch } = useFetchData({
    ladleId: ladleSelected,
    start: dateSelected ?? undefined,
    ladleSelected,
  });

  return (
    <>
      <HelmetDexteel title={`Ladle Maintenance DE`} />
      <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            Ladle Maintenance Data Entry
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }} elevation={2}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid
                item
                container
                xs={12}
                md={6}
                spacing={2}
                alignItems="center"
              >
                <Grid item>
                  <LadleSelector
                    value={ladleSelected}
                    onChange={(newValue: number): void => {
                      setLadleSelected(newValue);
                    }}
                    disabled={false}
                  />
                </Grid>
                <Grid item>
                  <DatePicker
                    label="From"
                    format="MM/DD/YYYY"
                    value={moment(dateSelected)}
                    onChange={(newValue): void => {
                      setDateSelected(newValue?.toDate() ?? null);
                    }}
                    slots={{
                      textField: (params: TextFieldProps): JSX.Element => (
                        <TextField
                          variant="outlined"
                          size="small"
                          {...params}
                        />
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                md={4}
                container
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(): void => setShowModal("RELINING")}
                    style={{ minHeight: 40 }}
                    disabled={!ladleSelected}
                  >
                    Relining
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(): void => setShowModal("PLUG")}
                    style={{ minHeight: 40 }}
                    disabled={!ladleSelected}
                  >
                    Change Plug
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <LadleMaintenanceTable
            ladleId={ladleSelected ?? 0}
            isLoading={loading}
            rows={ladleRelining}
            refreshData={refetch}
          />
        </Grid>

        <ErrorModal error={error} onHide={(): void => setError("")} />
        <DatePickerModal
          showModal={showModal}
          data={{
            id: null,
            ladleId: ladleSelected ?? 0,
            timestamp: new Date(),
          }}
          title={showModal === "PLUG" ? "CHANGE PLUG" : "RELINING"}
          onHide={(): void => {
            refetch();
            setShowModal("");
          }}
        />
      </Grid>
    </>
  );
};
